import { useCallback, useEffect, useState } from "react";
import { getYearCards } from "../api/budgetPortal";
import { SELECTED_BUDGET_MODULE_YEAR_KEY } from "../constants/budgetModule";
import { saveSelectedBudgetModuleYear } from "../utils/budgetFlow";

export const useBudgetModuleYears = (token) => {
  const [yearCards, setYearCards] = useState([]);
  const [selectedYear, setSelectedYearState] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const setSelectedYear = useCallback((year) => {
    setSelectedYearState(year);
    saveSelectedBudgetModuleYear(year);
  }, []);

  const reloadYears = useCallback(async () => {
    setLoading(true);
    setError("");

    try {
      const response = await getYearCards(token);
      const nextYearCards = response?.data ?? [];
      setYearCards(nextYearCards);

      const savedYear =
        window.localStorage.getItem(SELECTED_BUDGET_MODULE_YEAR_KEY) ?? "";
      const hasSavedYear = nextYearCards.some(
        (item) => item.financial_year === savedYear,
      );
      const nextSelectedYear = hasSavedYear
        ? savedYear
        : (nextYearCards[0]?.financial_year ?? "");

      setSelectedYear(nextSelectedYear);
    } catch (err) {
      setError(
        err?.response?.data?.message ||
        err.message ||
        "Unable to load budget module years",
      );
    }

    setLoading(false);
  }, [setSelectedYear, token]);

  useEffect(() => {
    reloadYears();
  }, [reloadYears]);

  return {
    yearCards,
    selectedYear,
    setSelectedYear,
    loading,
    error,
    reloadYears,
  };
};
